// extracted by mini-css-extract-plugin
export var particles = "particle-wrapper-module--particles--1ac23";